import { createContext } from 'react';

import { FormatterWithPrecision } from '../../core/types/formatter.js';

export const HistogramXFormatterContext = createContext<
  FormatterWithPrecision | undefined
>(undefined);

HistogramXFormatterContext['displayName'] = 'HistogramXFormatterContext';
